import axios from 'axios';
import router from "../router/index.js";
import store from "../store/index.js"


axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
    // 创建axios实例
const service = axios.create({
        // 请求URL公共部分
        // baseURL: process.env.VUE_APP_BASE_API,
        baseURL: 'https://www.bolycloud.com/', //打包地址
        // 超时
        timeout: 10000,
        headers: {
            'Content-Type': 'application/json;charset=UTF-8'
        }
    })
    // request拦截器
service.interceptors.request.use(config => {
    //在请求头中添加token
    config.headers.Authorization = `${localStorage.getItem('token')}`

    // console.log(config, 'config')

    // 是否需要设置 token
    // const isToken = (config.headers || {}).isToken === false
    //是否需要防止数据重复提交，默认防止
    //const isRepeatSubmit = (config.headers || {}).repeatSubmit === false 
    // if (getToken() && !isToken) {
    //     config.headers['Authorization'] = 'Bearer ' + getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    if (config.method === 'get' && config.params) {
        let url = config.url + '?';
        for (const propName of Object.keys(config.params)) {
            const value = config.params[propName];
            var part = encodeURIComponent(propName) + "=";
            if (value !== null && typeof(value) !== "undefined") {
                if (typeof value === 'object') {
                    for (const key of Object.keys(value)) {
                        let params = propName + '[' + key + ']';
                        var subPart = encodeURIComponent(params) + "=";
                        url += subPart + encodeURIComponent(value[key]) + "&";
                    }
                } else {
                    url += part + encodeURIComponent(value) + "&";
                }
            }
        }
        url = url.slice(0, -1);
        config.params = {};
        config.url = url;
    }
    return config
}, error => {
    console.log(error)
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
        //在这里做判断token过期
        // console.log(res)
        // console.log(store)
        switch (res.status) {
            case 200:
                return res.data;
            case 400:
                router.push({ path: '/400' })
                break;
            case 500:
                router.push({ path: '/500' })
                break;
            default:
                console.log('其他错误');
                let a = res.data.lcode.toString()
                let test = this.$t('message.camera.tokenflog')[a];
                let msgcode = "error";
                this.$messag[msgcode]({
                    message: test,
                    showClose: true,
                    duration: 5000,
                });
                localStorage.removeItem('token')
                this.$router.push('/login');
                // store.state.Errornumber = res.status;
                // store.state.Errormessage = res.data.msg;
                // router.push({ path: '/error' })
        }
    },
    error => {
        console.log('' + error);
        store.state.Errornumber = "Error";
        store.state.Errormessage = error;
        router.push({ path: '/error' })
        return Promise.reject(error)
    }
);
export default service;


// WEBPACK FOOTER //
// ./src/https/http.js